/**
 * Returns the URL as-is for use in <img src={...}>.
 * Kept for compatibility; WordPress media URLs load directly from WP.
 */
export function getWpImageSrc(url) {
  return url ?? '';
}

/**
 * Returns HTML unchanged. Kept for compatibility.
 * @param {string} html - Raw HTML string (e.g. post.content)
 * @returns {string} Same HTML
 */
export function rewriteWpContentImageUrls(html) {
  return html ?? '';
}
